import { render, staticRenderFns } from "./essays_table_header.vue?vue&type=template&id=1ffd23a7&scoped=true&"
import script from "./essays_table_header.vue?vue&type=script&lang=js&"
export * from "./essays_table_header.vue?vue&type=script&lang=js&"
import style0 from "./essays_table_header.vue?vue&type=style&index=0&id=1ffd23a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd23a7",
  null
  
)

export default component.exports